import { useMutationUpdateRiskProperty } from 'api/mutations/UpdateRiskProperty.mutation';

export const useAssigneeCellProvider = () => {
    return {
        api: {
            updateRiskProperty: {
                instance: useMutationUpdateRiskProperty(),
            },
        },
    };
};
